import 'es6-object-assign/auto';
import 'es6-promise/auto';
import Vue from 'vue';
import App from './App';
import MaintenanceRouter from './router/maintenance';
import TestDriveRouter from './router/test-drive';
import * as VueGoogleMaps from 'vue2-google-maps'
import Vuelidate from 'vuelidate'
import VueScrollTo from 'vue-scrollto'
import {store} from './store/store'
import {i18n} from './localizations/locales'
import axios from 'axios'
import vSelect from 'vue-select'
import SubmitButton from './components/SubmitButton'
import StepPreloader from './components/StepPreloader'
import {fixDealersStyles} from'./fixDealersStyles'
import envConfig from '../config/env.json'

axios.defaults.baseURL = envConfig['requests-path'];

const googleApiKey = 'AIzaSyABO6hz7JnLDFyr6_i9N30ki8CI0llfEv8';
Vue.use(VueGoogleMaps, {
    load: {
        key: googleApiKey,
        language: 'ru',
        libraries: ['places']
    }
});


Vue.use(Vuelidate);

JLR_BOOKING_WIDGET.vueScrollToOffset = 0;
const clientWidth = document.documentElement.clientWidth;

if (JLR_BOOKING_WIDGET.brandId === 1) {
    if (clientWidth > 1023) {
        JLR_BOOKING_WIDGET.vueScrollToOffset = -38;
    }
}

if (JLR_BOOKING_WIDGET.brandId === 2) {
    if (clientWidth > 1023) {
        JLR_BOOKING_WIDGET.vueScrollToOffset = -203;
    }
    if (clientWidth > 1135) {
        JLR_BOOKING_WIDGET.vueScrollToOffset = -168;
    }
}

Vue.use(VueScrollTo, {
    offset: JLR_BOOKING_WIDGET.vueScrollToOffset
});

Vue.config.productionTip = false;

const appOptions = {
    el: JLR_BOOKING_WIDGET.el,
    vSelect,
    store,
    i18n,
    render: h => h(App)
};

switch (JLR_BOOKING_WIDGET.form) {
    case 'Maintenance':
        appOptions.router = MaintenanceRouter;
        break;
    case 'TestDrive':
        appOptions.router = TestDriveRouter;
        break;
}

Vue.component('submit-button', SubmitButton);
Vue.component('step-preloader', StepPreloader);

const vm = new Vue(appOptions);

axios.interceptors.request.use(function (config) {
    config.headers['JLR-Locale'] = this.$store.state.locale;
    return config;
}.bind(vm));

axios.interceptors.response.use((res) => {
    return res;
}, function (err) {
    const res = err.response;
    const sessionHeader = res.config.headers['JLR-Session-Id'];
    const state = this.$store.state;

    if(res.data.message === 'Session is expired') {
        if(state.maintenance && state.maintenance.sessionId === sessionHeader) {
            state.maintenance.unforeseenSessionExpiration = true;
        }

        if(state.testDrive && state.testDrive.sessionId === sessionHeader) {
            state.testDrive.unforeseenSessionExpiration = true;
        }
    } else {
        return Promise.reject(res);
    }
}.bind(vm));

fixDealersStyles();



// WEBPACK FOOTER //
// ./src/main.js